module.exports = __webpack_public_path__ + "img/battery.7b8a365d.svg";